import React from 'react'

export const IconOutOfStock = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg fill="currentColor" x="0px" y="0px" viewBox="0 0 100 125" {...props}>
      <path d="M41.5 72c-3.4 0-6.2 2.8-6.2 6.3s2.8 6.3 6.2 6.3c3.4 0 6.2-2.8 6.2-6.3S45 72 41.5 72zm29.3 0c-3.4 0-6.2 2.8-6.2 6.3s2.8 6.3 6.2 6.3c3.4 0 6.2-2.8 6.2-6.3S74.2 72 70.8 72zM86 36.5S83.1 34 81.2 40c-3 11.1-6.8 22-6.8 22H38.6l-4.3-20.3-3.2-18.2c-.2-1.4-1.2-2.6-2.6-3l-14.7-3.8c-1.9-.5-3.8.2-4.2 2.1-.5 1.9.6 3.6 2.5 4.1l13.2 3.2 6.8 38.1s.2 4.3 4 4.3h40.2c3.2 0 3.8-3.4 3.8-3.4l7.6-23.8s2.7-3.6-1.7-4.8zM53.2 31L44 40.2c-.8.8-.8 2 0 2.8l1.9 1.9c.8.8 2 .8 2.8 0l9.2-9.2 9.2 9.2c.8.8 2 .8 2.8 0l1.9-1.9c.8-.8.8-2 0-2.8L62.6 31l9.2-9.2c.8-.8.8-2 0-2.8l-1.9-1.9c-.8-.8-2-.8-2.8 0l-9.2 9.2-9.2-9.2c-.8-.8-2-.8-2.8 0L44.1 19c-.8.8-.8 2 0 2.8l9.1 9.2z" />
    </svg>
  )
}
